import React, { useState, useEffect } from "react";
import { Check, Info } from "lucide-react";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import moment from "moment";

const backend = await new Backend().init();

export default function SymbolCard({ i, s }) {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(false);

  // ✅ Initialize selected state based on s.added
  useEffect(() => {
    setSelected(s.added === "1");
  }, [s.added]);

  // ✅ Add symbol (optimistic update)
  const AddSymbol = async () => {
    if (loading || selected) return;
    setSelected(true); // ⚡ instantly show tick
    setLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol: s,
      watchlist_id: "1",
    };

    try {
      const r = await backend.add_symbol(payload);
      if (r.error !== "False") {
        setSelected(false); // ❌ revert if failed
        toast.error(r.message);

        const newData = JSON.stringify(r.watchlist);
        await localStorage.setItem("watchlist", newData);
      } else {
        // ✅ Update the added flag locally if successful
        s.added = "1";
      }
    } catch {
      setSelected(false);
      toast.error("Failed to add symbol");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteOptions = async () => {
    if (loading || !selected) return;
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol_id: s.id,
      symboltype: s.type,
      symbol_name: s.symbol,
    };

    try {
      const r = await backend.delete_symbol(data);
      setLoading(false);
      if (r.error === "False") {
        // ✅ Update the added flag locally if successful
        const newData = JSON.stringify(r.watchlist);
        localStorage.setItem("watchlist", newData);
        s.added = "1";
        setSelected(false);
      } else {
        setSelected(true);
        toast.error(r.message);
      }
    } catch {
      setLoading(false);
      setSelected(true);
      toast.error("Failed to remove symbol");
    }
  };

  return (
    <div
      key={i}
      onClick={() => (selected ? handleDeleteOptions() : AddSymbol())}
      className={`flex justify-between items-center py-3 px-3 rounded-xl 
                   transition-all duration-200 cursor-pointer ${
                     loading ? "opacity-80" : ""
                   } hover:bg-[var(--hover)]`}
    >
      {/* Left Side — Selection + Symbol */}
      <div className="flex items-center gap-3">
        {/* ✅ Round Check Button */}
        <div
          className={`w-6 h-6 rounded-full flex items-center justify-center border-2 transition-all duration-200 ${
            selected
              ? "bg-[var(--primary)] border-[var(--primary)] shadow-md"
              : "border-[var(--primary)] bg-transparent"
          }`}
        >
          {selected ? (
            <Check className="w-4 h-4 text-white" />
          ) : (
            <div className="w-2.5 h-2.5 rounded-full bg-transparent" />
          )}
        </div>

        {/* Symbol Info */}
        <div className="flex flex-col leading-tight">
          <span className="text-[15px] flex items-center justify-center font-semibold text-[var(--text)]">
            <div>{s.symbol_display || s.symbol_name}</div>
            <div className="pl-2 small">
              {s.type === "nse_cash"
                ? "Equity"
                : moment(s.expiry_date).format("DD-MMM")}
            </div>
          </span>
          <span className="text-[13px] font-medium text-[var(--subtext)] mt-0.5 uppercase">
            {s.type === "nse"
              ? "NSE FUTURE"
              : s.type === "mcx"
                ? "MCX FUTURE"
                : s.type === "mcx_options"
                  ? "MCX OPTIONS"
                  : s.type === "fo"
                    ? "NSE OPTIONS"
                    : s.type === "nse_cash"
                      ? "NSE EQUITY"
                      : s.type === "comex_future"
                        ? "COMEX"
                        : s.type === "crypto_future"
                          ? "CRYPTO"
                          : s.type === "forex_future"
                            ? "FOREX"
                            : s.type === "us_stock"
                              ? "US STOCK"
                              : s.type === "sgx"
                                ? "SGX"
                                : s.type === "index"
                                  ? "OTHERS"
                                  : s.type === "dgcx"
                                    ? "DGCX"
                                    : s.type === "ncdex"
                                      ? "NCDEX"
                                      : "-|-"}
          </span>
        </div>
      </div>

      {/* Right Side — Info Button */}
      {/* <button
        onClick={(e) => {
          e.stopPropagation();
          toast.info(`${s.symbol_display} Info coming soon...`);
        }}
        className="w-8 h-8 flex items-center justify-center rounded-full 
                   border border-[var(--hover)] bg-[var(--background)] 
                   shadow-sm hover:shadow-md 
                   transition-all duration-200"
      >
        <Info className="w-4 h-4 text-[var(--primary)]" />
      </button> */}
    </div>
  );
}
